'use client'

import { useRestrictedAgeContext } from '@/context/RestrictedAgeContext'
import defaultLocale from '@/stores/defaultLocale'
import getLocale from '@/stores/locales'
import MinimumLegalAge from '@mercadoni/sinister/dist/cjs/minimumLegalAge'

const RestrictedAgeModal = () => {
  const { onSubmitRestrictedAge, openModal, closeRestrictedAge } =
    useRestrictedAgeContext()
  const copies = getLocale() || defaultLocale

  return (
    <MinimumLegalAge
      onSubmitRestrictedAge={onSubmitRestrictedAge}
      openModal={openModal}
      closeRestrictedAge={closeRestrictedAge}
      copies={copies}
    />
  )
}

export default RestrictedAgeModal
